<mat-card appearance="outlined">
  <mat-card-title [innerText]="'MAIN_APP_SERVICE_APP.artikelErfassen' | translate"></mat-card-title>
  <mat-card-content [formGroup]="formGroup">
    <span class="row">
      <mat-form-field>
        <mat-label>{{ "MAIN_APP_SERVICE_APP.artikelnummer" | translate }}</mat-label>
        <input matInput [id]="fldArtikelNummerKey" [formControlName]="fldArtikelNummerKey" [readonly]="roFields" required />
      </mat-form-field>

      <mat-form-field>
        <mat-label>{{ "MAIN_APP_SERVICE_APP.bezeichnung" | translate }}</mat-label>
        <input matInput [id]="fldBezeichnungKey" [formControlName]="fldBezeichnungKey" [readonly]="roFields" />
      </mat-form-field>
    </span>

    <span class="row">
      <mat-form-field>
        <mat-label>{{ "MAIN_APP_SERVICE_APP.anzahl" | translate }}</mat-label>
        <input matInput type="number" [id]="fldAnzahlKey" [formControlName]="fldAnzahlKey" (keyup)="onAnzahlChange($event)" (change)="onAnzahlChange($event)" required />
      </mat-form-field>

      <mat-form-field>
        <mat-label>{{ "MAIN_APP_SERVICE_APP.einheit" | translate }}</mat-label>
        <input matInput [id]="fldEinheitKey" [formControlName]="fldEinheitKey" [readonly]="roFields" (keyup)="onEinheitChange($event)" (change)="onEinheitChange($event)" />
      </mat-form-field>
    </span>

    <span class="row">
      <mat-form-field>
        <mat-label>{{
          "MAIN_APP_SERVICE_APP.Preis/Einheit" | translate
          }}</mat-label>
        <input matInput type="number" [id]="fldPreisProEinheitKey" [formControlName]="fldPreisProEinheitKey" (keyup)="onPreisChange($event)" (change)="onPreisChange($event)" />
      </mat-form-field>

      <mat-form-field>
        <mat-label>{{ "MAIN_APP_SERVICE_APP.menge" | translate }} Total
          {{ currMengeEinheit }}</mat-label>
	      <input [formControlName]="fldMengeTotalKey" [id]="fldMengeTotalKey" matInput readonly type="number"/>
      </mat-form-field>
    </span>

    <span class="row">
      <mat-form-field>
        <mat-label>Total</mat-label>
        <input matInput type="text" [id]="fldTotalPreisKey" [formControlName]="fldTotalPreisKey" [readonly]="true" />
      </mat-form-field>

      <mat-divider style="margin: 6px 0 6px 0"></mat-divider>

      <mat-form-field>
        <mat-label>{{ "MAIN_APP_SERVICE_APP.länge" | translate }} [mm]</mat-label>
        <input matInput type="number" [id]="fldLaengeKey" [formControlName]="fldLaengeKey" (keyup)="onLaengeChange($event)" (change)="onLaengeChange($event)" />
      </mat-form-field>
    </span>

    <span class="row">
      <mat-form-field>
        <mat-label>{{ "MAIN_APP_SERVICE_APP.breite" | translate }} [mm]</mat-label>
        <input matInput type="number" [id]="fldBreiteKey" [formControlName]="fldBreiteKey" (keyup)="onBreiteChange($event)" (change)="onBreiteChange($event)" />
      </mat-form-field>

      <mat-form-field>
        <mat-label>{{ "MAIN_APP_SERVICE_APP.dicke" | translate }} [mm]</mat-label>
        <input matInput type="number" [id]="fldDickeKey" [formControlName]="fldDickeKey" (keyup)="onDickeChange($event)" (change)="onDickeChange($event)" />
      </mat-form-field>

      <mat-form-field>
        <mat-label>{{ "MAIN_APP_SERVICE_APP.menge" | translate }}
          {{ currMengeEinheit }}</mat-label>
	      <input [formControlName]="fldMengeKey" [id]="fldMengeKey" [readonly]="true" matInput type="number"/>
      </mat-form-field>
    </span>

    <span class="row">
      <span *ngIf="isWLArticle">
        <mat-checkbox checked="true" [disableRipple]="true" [disabled]="true">
          WL-Artikel
        </mat-checkbox>
      </span>

      <mat-divider style="margin: 6px 0 6px 0"></mat-divider>

      <span *ngIf="showGoodwill">
        <mat-checkbox class="cbInaktiv-margin" [formControlName]="fldKulanzKey" [id]="fldKulanzKey">
          {{ "MAIN_APP_SERVICE_APP.kulanz" | translate }}
        </mat-checkbox>
      </span>
      <span *ngIf="showExpense">
        <mat-checkbox class="cbInaktiv-margin" [formControlName]="fldSpesenKey" [id]="fldSpesenKey">
          {{ "MAIN_APP_SERVICE_APP.spesen" | translate }}
        </mat-checkbox>
      </span>
    </span>
  </mat-card-content>

  <mat-dialog-actions>
	  <button (click)="save()" [disabled]="!formGroup.valid" [innerText]="'MAIN_APP_DIALOG.INPUT_DIALOG.save' | translate" class="confirm" mat-stroked-button></button>
    <button mat-stroked-button class="cancel" mat-dialog-close [innerText]="'MAIN_APP_DIALOG.INPUT_DIALOG.cancel' | translate"></button>
  </mat-dialog-actions>
</mat-card>
